import { useState } from 'react';
import { FaCog } from 'react-icons/fa';

import { SettingsChannelPrompt } from './SettingsChannelPrompt';
import { DBChannel } from '@core/types/types.db';
import { Button } from '@frontend/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@frontend/components/ui/dialog';

export function SettingsModalChannelPrompt({
  channel,
  onChannelUpdate,
  isReadOnly = false,
}: {
  channel: DBChannel;
  onChannelUpdate: (updatedChannel: DBChannel) => void;
  isReadOnly?: boolean;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [currentChannel, setCurrentChannel] = useState(channel);

  const handleChannelUpdate = (updatedChannel: DBChannel) => {
    setCurrentChannel(updatedChannel);
    onChannelUpdate(updatedChannel);
  };

  return (
    <>
      <Button
        size="sm"
        variant="ghost"
        onClick={() => setIsOpen(true)}
        title="Channel Settings"
      >
        <FaCog className="mr-2 size-4" />
        Settings
      </Button>

      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="max-w-3xl">
          <DialogHeader>
            <DialogTitle>Channel Settings: #{currentChannel.name}</DialogTitle>
          </DialogHeader>
          <div className="pb-6">
            <SettingsChannelPrompt
              channel={currentChannel}
              onChannelUpdate={handleChannelUpdate}
              onClose={() => setIsOpen(false)}
              isReadOnly={isReadOnly}
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
